import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import { EVENTOS_GA, REQUIRED_MESSAGE, URLS, ROUTE_BASEPATH } from '../../../../../constants'
import { useGlobal } from '../../../../../contexts/GlobalContext'
import { empty, isEmptyObject } from '../../../../../utils/helpers/helpers'

import Card from '@taglivros/oef_componentes/build/components/card'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Select from '@taglivros/oef_componentes/build/components/select'

import { useSolicitacaoCancelamento } from '../../../../../contexts/SolicitacaoCancelamentoContext'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../../utils/helpers/helpersAssinatura'
import { BOTAO_CONCLUIR_SUSPENSAO, BOTAO_VOLTAR } from '../constantsCancelarAssinatura'
import Navegacao from '../components/Navegacao/Navegacao'
import { PERGUNTA_MOTIVO, MOTIVOS_SUSPENSAO, VALOR_DEFAULT } from '../Suspensao/constantsSuspensao'
import { enviaEventoGA } from '../../../../../utils/helpers/helpersGA'
import { URLS_APP } from '../../../../../config'
import InlineLoader from '../../../../../components/InlineLoader/InlineLoader'

const Formulario = styled.div`
  margin-bottom: 70px;
  position: relative;
  width: 45%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin-bottom: 10px;
    width: 100%;
  }

  .row {
    margin-top: 30px;
  }

  .row--pergunta {
    ${StyleGuide.tipografia.textoDefault};
    ${StyleGuide.boldFonte};
    margin: 0 0 15px;

    @media(min-width: ${StyleGuide.mediaQuery.mobile}) {
      white-space: nowrap;
    }
  }
`

const LoadingWrapper = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, .7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
`

const WrapperFormulario = styled.div`
  position: relative;
`

const MotivosSuspensao = () => {
  const [ erros, setErros ] = useState( {} )
  const [ state, setState ] = useState( {} )
  const [ idAssinatura, setIdAssinatura ] = useState()
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const { assinaturaSuspensao, suspenderAssinatura, aguardandoSuspensao } = useSolicitacaoCancelamento()

  const handleEtapaAnterior = () => {
    enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES_VOLTAR.VOLTOU_SUSPENSAO )
  }

  useEffect( () => {
    if ( assinaturaSuspensao && modalidadeURL ) {
      navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}/${URLS.PLANO}/${URLS.CANCELAR_ASSINATURA_SUSPENSAO}/${URLS.CANCELAR_ASSINATURA_SUSPENSAO_CONCLUSAO}` )
    }
  }, [ assinaturaSuspensao, modalidadeURL ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  const handleSubmit = () => {
    let errosForm = {}
    if ( !state.motivo || state.motivo === VALOR_DEFAULT ) {
      errosForm = {
        ...errosForm,
        'motivo': REQUIRED_MESSAGE
      }
    }

    setErros( {
      ...errosForm
    } )

    if ( isEmptyObject( errosForm ) ) {
      suspenderAssinatura( state, idAssinatura )
    }

    enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.SUSPENDER )
  }

  const handleChange = event => {
    setState( {
      ...state,
      'motivo': event.value
    } )
    const { campo } = event
    if ( !empty( erros[ campo ] ) && event.value !== VALOR_DEFAULT ) {
      setErros( {
        ...erros,
        [ event.campo ]: null
      } )
    }
  }

  return (
    <Card
      className="card"
      largura="100%"
    >
      <WrapperFormulario>
        {
          aguardandoSuspensao ?
            <LoadingWrapper>
              <InlineLoader isCenter />
            </LoadingWrapper> : null
        }

        <Formulario onSubmit={ handleSubmit }>
          <div className="row">
            <p className="row--pergunta"> { PERGUNTA_MOTIVO } </p>

            <Select
              className="row--select"
              erro={ erros.motivo }
              itens={ Object.keys( MOTIVOS_SUSPENSAO ).map( item => ( {
                'campo': 'motivo',
                'value': MOTIVOS_SUSPENSAO[ item ].value,
                'visualizacao': MOTIVOS_SUSPENSAO[ item ].texto }
              ) ) }
              label=""
              name="motivo"
              onChange={ handleChange }
              required={ true }
            />
          </div>
        </Formulario>

        <Navegacao
          botaoContinuarDesabilitado={ !isEmptyObject( erros ) || isEmptyObject( state ) || aguardandoSuspensao }
          eventoBotaoContinuar={ handleSubmit }
          eventoBotaoVoltar={ handleEtapaAnterior }
          tituloContinuar={ BOTAO_CONCLUIR_SUSPENSAO }
          tituloVoltar={ BOTAO_VOLTAR }
          urlParaVoltar={ `/${modalidadeURL}/${URLS.PLANO}/${URLS.CANCELAR_ASSINATURA_SUSPENSAO}` }
        />
      </WrapperFormulario>
    </Card>
  )
}

export default MotivosSuspensao
